document.addEventListener("DOMContentLoaded", function () {
	var triggers = document.querySelectorAll('[data-bs-toggle="collapse"]');
	var OPEN_CLASS = "in";
	var DURATION = 300;

	function getTextNode(trigger) {
		return trigger.querySelector(".text") || trigger;
	}

	function shouldUpdateText(trigger) {
		return (
			trigger.hasAttribute("data-text-open") ||
			trigger.hasAttribute("data-text-close")
		);
	}

	function updateTriggerText(trigger, isOpen) {
		if (!shouldUpdateText(trigger)) return;

		var openText = trigger.getAttribute("data-text-open") || "OPEN";
		var closeText = trigger.getAttribute("data-text-close") || "CLOSE";
		var textEl = getTextNode(trigger);

		textEl.textContent = isOpen ? closeText : openText;
	}

	function setExpandedForTarget(targetEl, expanded) {
		for (var i = 0; i < triggers.length; i++) {
			var t = triggers[i];
			var sel = t.getAttribute("data-bs-target");
			if (!sel) continue;

			var el = document.querySelector(sel);
			if (el === targetEl) {
				t.setAttribute("aria-expanded", expanded ? "true" : "false");
				updateTriggerText(t, expanded);
			}
		}
	}

	function animateHeight(el, fromPx, toPx, done) {
		el.style.overflow = "hidden";
		el.style.height = fromPx + "px";
		el.style.transition = "height " + DURATION + "ms ease";

		el.offsetHeight;
		el.style.height = toPx + "px";

		var called = false;
		function cleanup() {
			if (called) return;
			called = true;
			el.style.transition = "";
			el.style.overflow = "";
			el.style.height = "";
			el.removeEventListener("transitionend", onEnd);
			if (done) done();
		}

		function onEnd(e) {
			if (e.propertyName !== "height") return;
			cleanup();
		}

		el.addEventListener("transitionend", onEnd);
		setTimeout(cleanup, DURATION + 50);
	}

	function openCollapse(el) {
		if (el.dataset.animating === "1") return;
		el.dataset.animating = "1";

		el.classList.add("collapse");
		el.style.display = "block";

		var full = el.scrollHeight;
		el.classList.remove(OPEN_CLASS);

		animateHeight(el, 0, full, function () {
			el.classList.add(OPEN_CLASS);
			el.dataset.animating = "0";
		});
	}

	function closeCollapse(el) {
		if (el.dataset.animating === "1") return;
		el.dataset.animating = "1";

		var current = el.scrollHeight;

		animateHeight(el, current, 0, function () {
			el.classList.remove(OPEN_CLASS);
			el.style.display = "";
			el.dataset.animating = "0";
		});
	}

	for (var i = 0; i < triggers.length; i++) {
		(function (trigger) {
			var targetSelector = trigger.getAttribute("data-bs-target");
			if (!targetSelector) return;

			var target = document.querySelector(targetSelector);
			if (!target) return;

			var initiallyOpen = target.classList.contains(OPEN_CLASS);
			trigger.setAttribute("aria-expanded", initiallyOpen ? "true" : "false");
			updateTriggerText(trigger, initiallyOpen);

			trigger.addEventListener("click", function (e) {
				if (trigger.tagName.toLowerCase() === "a") e.preventDefault();

				var isOpen = target.classList.contains(OPEN_CLASS);
				if (isOpen) {
					closeCollapse(target);
					setExpandedForTarget(target, false);
				} else {
					openCollapse(target);
					setExpandedForTarget(target, true);
				}
			});
		})(triggers[i]);
	}
});
